<!-- ---------------------- contentTemplateContainer ----------------------- -->

@if ($page(); as page) {
  <ng-container [ngSwitch]="page.template">
    <ng-container
      *ngSwitchCase="'HomepageTemplate'"
      [ngTemplateOutlet]="HomepageTemplate"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'TemplateSideBar'"
      [ngTemplateOutlet]="TemplateSideBar"
    ></ng-container>

    <ng-container
      *ngSwitchCase="'CartPageTemplate'"
      [ngTemplateOutlet]="CartPageTemplate"
    ></ng-container>

    <ng-container
      *ngSwitchCase="'CheckoutAccountPageTemplate'"
      [ngTemplateOutlet]="CheckoutAccountPageTemplate"
    ></ng-container>

    <ng-container
      *ngSwitchCase="'MultiStepCheckoutSummaryPageTemplate'"
      [ngTemplateOutlet]="MultiStepCheckoutSummaryPageTemplate"
    ></ng-container>

    <ng-container
      *ngSwitchCase="'OrderConfirmationPageTemplate'"
      [ngTemplateOutlet]="OrderConfirmationPageTemplate"
    ></ng-container>

    <ng-container
      *ngSwitchCase="'StoreFinderPageTemplate'"
      [ngTemplateOutlet]="StoreFinderPageTemplate"
    ></ng-container>

    <ng-container
      *ngSwitchCase="'ErrorPageTemplate'"
      [ngTemplateOutlet]="ErrorPageTemplate"
    >
    </ng-container>

    <ng-container
      *ngSwitchDefault
      [ngTemplateOutlet]="templateDefault"
    ></ng-container>
  </ng-container>
}
<!-- -------------------------- HomepageTemplate --------------------------- -->
<ng-template #HomepageTemplate>
  @for (slot of $topSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #topSlotsRenderer></ng-template>
    </section>
  }
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- TemplateDefault --------------------------- -->
<ng-template #templateDefault>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- CartPageTemplate --------------------------- -->
<ng-template #CartPageTemplate>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [class.hide]="
        slot.position === 'EmptyCartMiddleContent' &&
        ($cartState().loading || $cartState().count)
      "
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- CheckoutPageTemplate --------------------------- -->
<ng-template #CheckoutAccountPageTemplate>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- MultiStepCheckoutSummaryPageTemplate --------------------------- -->
<ng-template #MultiStepCheckoutSummaryPageTemplate>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- MultiStepCheckoutSummaryPageTemplate --------------------------- -->
<ng-template #OrderConfirmationPageTemplate>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- StoreFinderPageTemplate --------------------------- -->
<ng-template #StoreFinderPageTemplate>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- -------------------------- TemplateFullWidth -------------------------- -->
<ng-template #TemplateFullWidth>
  @for (slot of $pageSlots(); track $index) {
    <section
      [attr.position]="slot.position"
      [class]="slot.position"
      [class.page-fold]="slot === $pageFold()"
      [class.has-components]="slot.components?.component?.length"
      [boelsSlotDecorator]="slot.properties"
    >
      <ng-template #slotsRenderer></ng-template>
    </section>
  }
</ng-template>

<!-- --------------------------- TemplateSideBar --------------------------- -->
<ng-template #TemplateSideBar>
  @if ($topSlots(); as topSlots) {
    @for (slot of topSlots; track $index) {
      <section
        [attr.position]="slot.position"
        [class]="slot.position"
        [class.page-fold]="slot === $pageFold()"
        [class.has-components]="slot.components?.component?.length"
        [boelsSlotDecorator]="slot.properties"
      >
        <ng-template #topSlotsRenderer></ng-template>
      </section>
    }
  }
  <boels-vertical-aligner innerWidth="wide">
    <div class="TemplateSideBarMiddle">
      @if ($pageSlots(); as pageSlots) {
        @for (slot of pageSlots; track $index) {
          <section
            [attr.position]="slot.position"
            [class]="slot.position"
            [class.page-fold]="slot === $pageFold()"
            [class.has-components]="slot.components?.component?.length"
            [boelsSlotDecorator]="slot.properties"
          >
            <ng-template #slotsRenderer></ng-template>
          </section>
        }
      }
    </div>
  </boels-vertical-aligner>

  @if ($bottomSlots(); as bottomSlots) {
    @for (slot of bottomSlots; track $index) {
      <section
        [attr.position]="slot.position"
        [class]="slot.position"
        [class.page-fold]="slot === $pageFold()"
        [class.has-components]="slot.components?.component?.length"
        [boelsSlotDecorator]="slot.properties"
      >
        <ng-template #bottomSlotsRenderer></ng-template>
      </section>
    }
  }
</ng-template>

<!-- -------------------------- ErrorPageTemplate --------------------------- -->
<ng-template #ErrorPageTemplate>
  <boels-page-not-found>
    @if ($pageSlots(); as pageSlots) {
      @for (slot of pageSlots; track $index) {
        <section
          [attr.position]="slot.position"
          [class]="slot.position"
          [class.page-fold]="slot === $pageFold()"
          [class.has-components]="slot.components?.component?.length"
          [boelsSlotDecorator]="slot.properties"
        >
          <ng-template #slotsRenderer></ng-template>
        </section>
      }
    }
  </boels-page-not-found>
</ng-template>
